import React from "react";
import { toClass } from "recompose";
import styled from "styled-components/macro";
import { Slider as AntdSlider } from "antd";
import * as R from "ramda";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const Side = styled.div`
  margin-right: ${({ side }) => (side === "right" ? 0 : 12)}px;
  margin-left: ${({ side }) => (side === "left" ? 0 : 12)}px;
  width: 96px;
`;

const Middle = styled.div`
  width: 100%;
`;

const Slider = props => {
  const formatter = R.propOr(R.identity, "tipFormatter")(props);
  const hasValue = !R.either(R.isEmpty, R.isNil)(props.value);

  return (
    <Container>
      {hasValue && <Side side="left">{formatter(props.value[0])}</Side>}
      <Middle>
        <AntdSlider {...props} />
      </Middle>
      {hasValue && <Side side="right">{formatter(props.value[1])}</Side>}
    </Container>
  );
};

export default toClass(Slider);
